import { useCurrentStep } from 'api/guide';
import LoadingButton from 'components/shared/LoadingButton';
import { useSSOGuideProgress } from 'contexts/GuideProgressContext';
import { useIdPConfigContext } from 'contexts/IdPConfigContext';
import React from 'react';
import { useStepNavigate, useTestingNavigate } from 'utils/navigation';

interface ISSOContinueButtonProps {
	disabled?: boolean;
}
const SSOContinueButton: React.FC<ISSOContinueButtonProps> = ({
	disabled = false
}) => {
	const { guideStepNum } = useIdPConfigContext();

	const { navigateToNextStep } = useStepNavigate();
	const { navigateToTesting } = useTestingNavigate();
	const { setStepCompleted: setSSOStepCompleted } = useSSOGuideProgress();
	const { data: currentStepData } = useCurrentStep();

	return (
		<LoadingButton
			data-testid="guide-continue-button"
			variant="contained"
			disabled={disabled}
			onClick={() => {
				setSSOStepCompleted(guideStepNum!);
				if (currentStepData?.isLastStep) {
					navigateToTesting();
				} else {
					navigateToNextStep();
				}
			}}
		>
			{intl.tr('general.continue')}
		</LoadingButton>
	);
};

export default SSOContinueButton;
